"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SEND_BOX = void 0;
exports["default"] = setSendBox;
var SET_SEND_BOX = 'WEB_CHAT/SET_SEND_BOX';
exports.SET_SEND_BOX = SET_SEND_BOX;

function setSendBox(text) {
  return {
    type: SET_SEND_BOX,
    payload: {
      text: text
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfU0VORF9CT1giLCJzZXRTZW5kQm94IiwidGV4dCIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2V0U2VuZEJveC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfU0VORF9CT1ggPSAnV0VCX0NIQVQvU0VUX1NFTkRfQk9YJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0U2VuZEJveCh0ZXh0KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VUX1NFTkRfQk9YLFxuICAgIHBheWxvYWQ6IHsgdGV4dCB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9TRU5EX0JPWCB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsWUFBWSxHQUFHLHVCQUFyQjs7O0FBRWUsU0FBU0MsVUFBVCxDQUFvQkMsSUFBcEIsRUFBMEI7RUFDdkMsT0FBTztJQUNMQyxJQUFJLEVBQUVILFlBREQ7SUFFTEksT0FBTyxFQUFFO01BQUVGLElBQUksRUFBSkE7SUFBRjtFQUZKLENBQVA7QUFJRCJ9